import React from 'react'

const PasteIcon = (props: any = {}) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M16 4.00174C18.175 4.01385 19.3529 4.1103 20.1213 4.87868C21 5.75736 21 7.17157 21 10V16C21 18.8284 21 20.2426 20.1213 21.1213C19.2426 22 17.8284 22 15 22H9C6.17157 22 4.75736 22 3.87868 21.1213C3 20.2426 3 18.8284 3 16V10C3 7.17157 3 5.75736 3.87868 4.87868C4.64706 4.1103 5.82497 4.01385 8 4.00174" stroke={props?.color ?? "var(--primary)"} strokeWidth="1.5" />
            <path d="M7 14.5H15" stroke={props?.color ?? "var(--primary)"} strokeWidth="1.5" strokeLinecap="round" />
            <path d="M7 18H12.5" stroke={props?.color ?? "var(--primary)"} strokeWidth="1.5" strokeLinecap="round" />
            <path d="M8 3.5C8 2.67157 8.67157 2 9.5 2H14.5C15.3284 2 16 2.67157 16 3.5V4.5C16 5.32843 15.3284 6 14.5 6H9.5C8.67157 6 8 5.32843 8 4.5V3.5Z" stroke={props?.color ?? "var(--primary)"} strokeWidth="1.5" />
        </svg>)
}

export default PasteIcon